export default "__VITE_ASSET__BU$PNybN__"